import { EventEmitter, ElementRef } from '@angular/core';
import { CommonService } from '../../app/common.service';
import { ActivatedRoute } from '@angular/router';
var ComponentsApproach = (function () {
    function ComponentsApproach(el, commonService, route) {
        this.el = el;
        this.commonService = commonService;
        this.route = route;
        this.isTencent = false;
        this.isShowFull = true;
        this.onGoCourse = new EventEmitter();
        this.assetsRoute = "../../assets";
        this.isCamp = false;
        this.buttonTheme = {
            'position': 'inherit',
            'fontSize': 'fontSize15',
            'buttonElem': [
                {
                    'color': 'blue',
                    'text': '',
                    'className': 'inlineBlockRadiusBtn width-100 margin-auto'
                }
            ]
        }; //按钮主题
    }
    ComponentsApproach.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.label = this.theme.label;
        this.isCamp = !!localStorage.getItem('skuId');
        this.buttonTheme.buttonElem[0].text = this.theme.btnTxt;
        this.buttonTheme.buttonElem[0].className = this.theme.colorSystem === 'light' ? 'inlineBlockRadiusBtn width-60 margin-auto' : this.buttonTheme.buttonElem[0].className;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        if (this.type) {
            this.theme.desc = '请点击左侧边栏中能力考核进行学习 ~';
        }
        console.log('approach');
    };
    ComponentsApproach.prototype.ngAfterViewInit = function () {
    };
    return ComponentsApproach;
}());
export { ComponentsApproach };



// WEBPACK FOOTER //
// ./src/component/approach/components.approach.ts.pre-build-optimizer.js